<template>
  <div>
    <wss-player v-if="stream!==null"
                style="background: #000;height: 100%;"
                :stream="stream"
                @reconnect="reconnect"
                @capture-picture="capturePicture"/>
    <search-face-dialog v-if="visibleFaceDialog"
                        :base64="base64Image"
                        :dialog-visible="visibleFaceDialog"
                        @handle-close="visibleFaceDialog=false"
    />
  </div>
</template>

<script>
import {answer, getHikStreamVO} from "@/api/kecang";
import lodashGet from 'lodash/get'
import lodashKeyBy from 'lodash/keyBy'
import WssPlayer from "@/components/player/WssPlayer.vue";
import HikStreamVO from "@/components/player/HikStreamVO";
import SearchFaceDialog from "@/views/Eventhandling/components/SearchFaceDialog.vue";

export default {
  components: {SearchFaceDialog, WssPlayer},
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      stream: null,
      visibleFaceDialog: false, // 人脸识别弹窗
      base64Image: null, // 视频截图
    };
  },
  // watch: {
  //   id: {
  //     deep: true,// true 深度监听
  //     handler(val, oldVal) {
  //       this.playHikStream(this.id)
  //     }
  //   }
  // },
  created() {
    this.playHikStream(this.id)
  },
  methods: {
    // 获取视频播放地址
    async playHikStream(id) {
      const result = await getHikStreamVO(id, 'wss')
      // console.log(['CameraCard.vue playHikStream', result])
      if (result.code === 'A00000') {
        if (result.rowCount > 0) {
          this.stream = new HikStreamVO({key: id, ...result.data[0]})
        } else {
          this.stream = null
          // this.$message.error('视频播放加载失败，请确认设备是否正常注册到平台')
        }
      } else {
        this.stream = null
        console.error(`视频播放地址获取失败：${result.message}`)
        // this.$message.error(result.message)
      }
    },
    // 播放断开重连
    reconnect({key, protocol}) {
      console.log({key, protocol})
      this.playHikStream(key)
    },
    // 视频截图
    capturePicture(base64) {
      console.log(base64)
      this.visibleFaceDialog = true
      this.base64Image = base64
    }
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/Eventhandling/components/CameraCard.vue